var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height d-block pb-0 border-xxx"},[(_vm.isCompatibleBrowser)?[_c(_vm.formComponent,_vm._g({ref:"form",tag:"component",staticClass:"d-flex flex-wrap fill-height"},_vm.formEvents))]:[_c('compatible-browser',{attrs:{"is-login":true},on:{"click":_vm.onAcceptRisk}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }